import { useEffect, useRef, useState } from "react";
import Logo from "../../assets/svg/logo_splash.svg";
import Background from "../../assets/images/background.jpg";
import { Link, useNavigate } from "react-router-dom";
import useLoadingBar from "../../hooks/useLoading";
import { authenticate } from "../../services/ api_services";
import { isEmpty, isString } from "lodash";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { axiosInstance, setHeaderDb } from "../../services/axiosConfig";
import useAuth from "../../hooks/useAuth";
import useToast from "../../hooks/useToast";
import { ROLES } from "../../core/constants";
import { ToastTypes } from "../../context/ToastProvider";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import SelectMenu from "../../components/SelectMenu";

export default function Login() {
    const navigate = useNavigate();
    const { setLoading } = useLoadingBar();
    const { login } = useAuth();
    const { showToast } = useToast();

    const initialRequest = {
        admin_id: "",
        password: "",
    };

    const initialLoginSystems = [
        { id: "", name: "선택" },
        { id: "oxygen", name: "활성산소" },
        { id: "urinalysis", name: "소변검사" },
    ];

    const [request, setRequest] = useState(initialRequest);
    const [showPass, setShowPass] = useState(false);
    const [loginSystems, setLoginSystem] = useState(initialLoginSystems);
    const [selectedLoginSystem, setSelectedLoginSystem] = useState(initialLoginSystems[0].id);

    const idRef = useRef();
    const passRef = useRef();
    const btnLoginRef = useRef();

    useEffect(() => {
        localStorage.clear();
        Cookies.remove();
        idRef.current.focus();
    }, []);

    useEffect(() => {
        console.log("Selected Login System ==> ", selectedLoginSystem);
        setHeaderDb(selectedLoginSystem);
        localStorage.setItem("X-DB-KEY", selectedLoginSystem);
    }, [selectedLoginSystem]);

    const handleSubmit = async (e) => {
        // e.preventDefault();
        console.log("SELECTTED LOGIN SYSTEM =>  ", selectedLoginSystem);
        if (isEmpty(selectedLoginSystem)) {
            showToast(ToastTypes.WARNING, "안내", "접속 시스템을 선택해 주세요!");
            return;
        }

        try {
            //Call api auth endpoint
            setLoading(true);
            console.log("[Authentication request] ", request);
            await authenticate(request).then((response) => {
                console.log("🚀 ~ file: Login.jsx:63 ~ handleSubmit ~ response:", response);
                if (response && response.data && response.data.resultCode === 200) {
                    if (response.data.detail && isString(response.data.detail)) {
                        const token = response.data.detail;
                        const decodedToken = jwtDecode(token);
                        console.log("🚀 ~ awaitauthenticate ~ decodedToken:", decodedToken);
                        Cookies.set("access-token", token, { expires: 1 });
                        const adminInfo = {
                            admin_seq: decodedToken.sub ?? "",
                            admin_id: decodedToken.admin_id,
                            admin_level_cd: decodedToken.admin_level_cd,
                            admin_level_nm: decodedToken.admin_level_nm,
                            admin_name: decodedToken.admin_name,
                            admin_type: decodedToken.admin_type,
                            admin_org_id: decodedToken.org_id ?? 999,
                        };
                        axiosInstance.interceptors.request.use(
                            (config) => {
                                config.headers["Authorization"] = `Bearer ${token}`;
                                return config;
                            },
                            (error) => {
                                return Promise.reject(error);
                            }
                        );
                        setLoading(false);

                        console.log("Admin Info ==> ", adminInfo);
                        login(adminInfo);
                        // setAuth(adminInfo);

                        sessionStorage.setItem("adminOrgId", adminInfo.admin_org_id);
                        sessionStorage.setItem("adminSeq", adminInfo.admin_seq);
                        sessionStorage.setItem("adminLevelCd", adminInfo.admin_level_cd);
                        console.log("adminOrgId", adminInfo.admin_org_id, "adminSeq", adminInfo.admin_seq, "adminLevelCd", adminInfo.admin_level_cd);

                        if (adminInfo.admin_level_cd === ROLES.Admin || adminInfo.admin_level_cd === ROLES.Volunteer) {
                            navigate("/ad/dashboard", { replace: true });
                        } else {
                            navigate("/user/dashboard", { replace: true });
                        }
                    }
                } else if (response.data && response.data.resultCode === 404) {
                    setLoading(false);
                    showToast(
                        ToastTypes.ERROR,
                        "실패",
                        "아이디(로그인 전용 아이디) 또는 비밀번호를 잘못 입력했습니다. 입력하신 내용을 다시 확인해주세요."
                    );
                } else if (response.data && response.data.resultCode === 403) {
                    setLoading(false);
                    showToast(
                        ToastTypes.ERROR,
                        "접근 실패",
                        "관리자 심사 중인 아이디입니다. 본사에 문의하세요."
                    );
                } else {
                    showToast(
                        ToastTypes.ERROR,
                        "실패",
                        "아이디(로그인 전용 아이디) 또는 비밀번호를 잘못 입력했습니다. 입력하신 내용을 다시 확인해주세요."
                    );
                }
            });
        } catch (e) {
            setLoading(false);
            console.log("Error complicated to login => ", e);
            showToast(
                ToastTypes.ERROR,
                "실패",
                "아이디(로그인 전용 아이디) 또는 비밀번호를 잘못 입력했습니다. 입력하신 내용을 다시 확인해주세요."
            );
        }
    };

    const handleMouseUp = () => {
        setShowPass(false);
    };

    const handleMouseDown = () => {
        setShowPass(true);
    };

    const handleKeyDown = (e, id) => {
        // console.log("🚀 ~ handleKeyDown ~ id:", id);
        // console.log("e ==> ", e);
        if (e.keyCode === 13) {
            if (id === "id") {
                passRef.current.focus();
            } else if (id === "pass") {
                btnLoginRef.current.focus();
            }
        }
    };

    function navigateToSignUp() {
        if (isEmpty(selectedLoginSystem)) {
            showToast(ToastTypes.WARNING, "안내", "접속 시스템을 선택해 주세요!");
            return;
        }
        navigate("/register");
    }

    return (
        <>
            <div className="relative h-screen w-screen bg-cover bg-center">
                <div className="flex h-full w-full">
                    <img src={Background} alt="background" className="absolute top-0 left-0 w-full h-full object-cover" />
                    <div className="relative flex h-full w-full">
                        <div className="flex-1" />
                        <div className="flex-1 flex justify-center items-start bg-white">
                            <div className="w-full">
                                <div className="w-full justify-center px-6 py-12 ">
                                    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                                        <img className="mx-auto" src={Logo} alt="Log Images" />
                                    </div>

                                    <div className="bg-white px-2 py-12 sm:px-2 mt-10 sm:mx-auto sm:w-full sm:max-w-md">
                                        <div className="space-y-6">
                                            <div>
                                                <div className="flex">
                                                    <label className="block text-base font-semibold leading-6 text-gray-700">아이디</label>
                                                    <label className="ml-1 text-base font-semibold leading-6 text-red-500"> *</label>
                                                </div>
                                                <div className="mt-2">
                                                    <input
                                                        className="block w-full rounded-lg border-0 py-3 text-gray-900 shadow ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 pl-3"
                                                        placeholder="아이디를 입력하세요"
                                                        required
                                                        ref={idRef}
                                                        id="userId"
                                                        name="userId"
                                                        type="text"
                                                        autoComplete="off"
                                                        value={request.admin_id}
                                                        onKeyDown={(e) => handleKeyDown(e, "id")}
                                                        onChange={(e) => {
                                                            setRequest((preVal) => {
                                                                return {
                                                                    ...preVal,
                                                                    admin_id: e.target.value,
                                                                };
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <div className="flex">
                                                    <label className="block text-base font-semibold leading-6 text-gray-700">
                                                        비밀번호
                                                    </label>
                                                    <label className="ml-1 text-base font-semibold leading-6 text-red-500"> *</label>
                                                </div>
                                                <div className="relative w-full max-w-md mt-2">
                                                    <input
                                                        placeholder="비밀번호를 입력하세요"
                                                        className="block w-full rounded-lg shadow border-0 py-3 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 pl-3"
                                                        required
                                                        ref={passRef}
                                                        id="password"
                                                        name="password"
                                                        type={showPass ? "text" : "password"}
                                                        value={request.password}
                                                        onKeyDown={(e) => handleKeyDown(e, "pass")}
                                                        onChange={(e) => {
                                                            setRequest((preVal) => {
                                                                return {
                                                                    ...preVal,
                                                                    password: e.target.value,
                                                                };
                                                            });
                                                        }}
                                                    />
                                                    <button
                                                        className="absolute inset-y-0 right-0 flex items-center pr-3"
                                                        onMouseDown={handleMouseDown}
                                                        onMouseUp={handleMouseUp}
                                                        onMouseLeave={handleMouseUp}
                                                    >
                                                        {showPass && (
                                                            <FaRegEye className="-ml-0.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                        )}
                                                        {!showPass && <FaRegEyeSlash className="-ml-0.5 h-5 w-5 text-gray-400" />}
                                                    </button>
                                                </div>
                                            </div>

                                            <div>
                                                <button
                                                    ref={btnLoginRef}
                                                    className="flex w-full justify-center items-center rounded-lg bg-blue-700 px-3 py-4 text-base font-semibold leading-6 text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                                    onClick={() => handleSubmit()}
                                                >
                                                    로그인
                                                </button>
                                            </div>
                                            <div className=" shadow-sm border py-6 px-4 rounded-lg flex justify-start items-center w-full">
                                                <span className="w-2/6 text-sm font-bold leading-6 pr-6 text-gray-900">접속 시스템</span>
                                                <div className="w-4/6">
                                                    <SelectMenu
                                                        options={loginSystems}
                                                        selectedId={selectedLoginSystem}
                                                        onSelect={(val) => {
                                                            console.log("🚀 ~ Simulation ~ val:", val);
                                                            setSelectedLoginSystem(val.id);
                                                            // setSelectedLoginSystem((preVal) => {
                                                            //     return {
                                                            //         ...preVal,
                                                            //         id: val.id,
                                                            //     };
                                                            // });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-center mt-10">
                                        <p className="text-center text-base font-semibold text-gray-700">
                                            아직 계정이 없으신가요?{" "}
                                            <label
                                                // to={"/register"}
                                                className="font-semibold leading-6 text-blue-700 hover:underline hover:text-blue-600 underline underline-offset-4 cursor-pointer "
                                                onClick={() => navigateToSignUp()}
                                            >
                                                회원가입
                                            </label>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="h-screen w-full flex min-w-full justify-center flex-col">
                <img src={Background} />
                <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:grid-rows-2 sm:gap-x-6">
                    <div />
                    <div>
                        <div className="h-screen flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 ">
                            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                                <img className="mx-auto" src={Logo} alt="Log Images" />
                            </div>

                            <div className="bg-white px-8 py-16 shadow-xl sm:rounded-2xl ring-1 ring-gray-200 sm:px-12 mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                                <form className="space-y-6" onSubmit={handleSubmit}>
                                    <div>
                                        <label className="block text-sm font-semibold leading-6 text-gray-900">아이디</label>
                                        <div className="mt-2">
                                            <input
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-3"
                                                required
                                                ref={idRef}
                                                id="userId"
                                                name="userId"
                                                type="text"
                                                autoComplete="off"
                                                value={request.admin_id}
                                                onChange={(e) => {
                                                    setRequest((preVal) => {
                                                        return {
                                                            ...preVal,
                                                            admin_id: e.target.value,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold leading-6 text-gray-900">비밀번호</label>
                                        <div className="mt-2">
                                            <input
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 pl-3"
                                                required
                                                ref={passRef}
                                                id="password"
                                                name="password"
                                                type="password"
                                                value={request.password}
                                                onChange={(e) => {
                                                    setRequest((preVal) => {
                                                        return {
                                                            ...preVal,
                                                            password: e.target.value,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <button className="flex w-full justify-center items-center rounded bg-blue-600 px-3 py-3 text-base font-semibold leading-6 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500">
                                            로그인
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div className="flex justify-center mt-10">
                                <p className="text-center text-sm font-normal text-gray-500">
                                    계정이 없으신가요?{" "}
                                    <Link
                                        to={"/register"}
                                        className="font-semibold leading-6 text-blue-700 hover:underline hover:text-blue-600"
                                    >
                                        회원가입
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
}
